<div class="flex">
  <div class="col-fixed px-0" [style.width.px]="50" *ngIf="!readonly">
    <button pButton icon="fas fa-trash" type="button" class="p-button-danger" (click)="remove.emit()">
    </button>
  </div>

  <div class="col px-0 md:pt-0 inline-flex flex-wrap">
    <label class="col-12 px-0 hide-from-small" for="recipe_medicine_0_{{turn}}">{{screen.medicine}}:</label>
    <div class="col-12 md:col-3 px-0 md:pr-2">
      <input pInputText type="text" name="recipe_medicine_{{idx}}_{{turn}}" [(ngModel)]="recipe.medicineHelp!.name"
        (ngModelChange)="handleAutocompleteChange()" autocomplete="off" class="uppercase no-margin"
        [placeholder]="screen.medicinePlaceholder" validation [readonly]="readonly" *ngIf="!readonly" />

      <span *ngIf="readonly">{{recipe.medicineHelp?.name}}</span>
    </div>

    <label class="col-12 px-0 hide-from-small" for="recipe_qty_0_{{turn}}">{{screen.quantity}}:</label>
    <div class="col-12 md:col-3 px-0 md:px-2">
      <input pInputText type="text" name="recipe_qty_{{idx}}_{{turn}}" [(ngModel)]="recipe.medicineHelp!.quantity"
        (ngModelChange)="handleAutocompleteChange()" autocomplete="off" class="uppercase no-margin"
        [placeholder]="screen.quantityPlaceholder" validation [readonly]="readonly"
        [required]="recipe.medicineHelp!.name != null && recipe.medicineHelp!.name !== ''" *ngIf="!readonly" />

      <span *ngIf="readonly">{{recipe.medicineHelp?.quantity}}</span>
    </div>

    <label class="col-12 px-0 hide-from-small" for="recipe_instructions_0_{{turn}}">{{screen.instructions}}:</label>
    <span class="col px-0 md:pl-2">
      <textarea pInputTextarea name="recipe_instructions_{{idx}}_{{turn}}"
        [(ngModel)]="recipe.medicineHelp!.instructions" (ngModelChange)="handleAutocompleteChange()" [rows]="3"
        [placeholder]="screen.instructionsPlaceholder" validation [readonly]="readonly" class="uppercase no-margin"
        [required]="recipe.medicineHelp!.name != null && recipe.medicineHelp!.name !== ''" *ngIf="!readonly"></textarea>

      <span *ngIf="readonly">{{recipe.medicineHelp?.instructions}}</span>
    </span>
  </div>

</div>